import { NO_INPUT, PlayerInput, PlayerInputBoolKey } from '../shared/types'

// Positions PHYSIQUES (event.code) : robuste au clavier QWERTZ suisse.
// Flèches = déplacement, A/S = creuser gauche/droite, Espace = objet, Maj = dash (Lot D).
const MAP: Record<string, PlayerInputBoolKey> = {
  ArrowLeft: 'left', ArrowRight: 'right', ArrowUp: 'up', ArrowDown: 'down',
  KeyA: 'digL', KeyS: 'digR', Space: 'use', ShiftLeft: 'dash', ShiftRight: 'dash',
}

export interface Keyboard {
  current(): PlayerInput
  attach(): void
  detach(): void
}

export function createKeyboard(): Keyboard {
  const state: PlayerInput = { ...NO_INPUT }
  // preventDefault UNIQUEMENT sur les touches mappées (sinon on bloquerait F5, etc.).
  const down = (e: KeyboardEvent) => { const k = MAP[e.code]; if (k) { state[k] = true; e.preventDefault() } }
  const up = (e: KeyboardEvent) => { const k = MAP[e.code]; if (k) { state[k] = false; e.preventDefault() } }
  return {
    current: () => ({ ...state }),
    attach() { addEventListener('keydown', down); addEventListener('keyup', up) },
    detach() { removeEventListener('keydown', down); removeEventListener('keyup', up) },
  }
}
